import type { MPAInterceptedResponse } from '@repo/api-gw-sdk';

export const isMPAInterceptedResponse = (
  body: unknown
): body is MPAInterceptedResponse => {
  if (!body || typeof body !== 'object') return false;
  const candidate = body as Record<string, unknown>;
  return (
    typeof candidate.mpaRequest === 'object' &&
    candidate.mpaRequest !== null &&
    typeof candidate.mpaPolicies === 'object' &&
    candidate.mpaPolicies !== null
  );
};

// MPA-intercepted responses are absorbed by the SDK middleware before the
// caller awaits, so the runtime value is either the success type or undefined
// (when the original op was deferred for approval). Use this at the DAL
// boundary to drop the MPA branch from the codegen union.
export const stripMpa = <T>(
  p: Promise<MPAInterceptedResponse | T>
): Promise<T | undefined> =>
  p.then((res) => (isMPAInterceptedResponse(res) ? undefined : res));

export class MpaCancelledError extends Error {
  constructor() {
    super('Operation cancelled by user');
    Object.setPrototypeOf(this, MpaCancelledError.prototype);
    this.name = 'MpaCancelledError';
  }
}
